<template xmlns="http://www.w3.org/1999/html">
  <drag-drawer v-model="showDrawer"
               :width.sync="width"
               :min-width="minWidth"
               :inner="true"
               :transfer="false"
               :placement="placementComputed"
               :draggable="true"
               :mask="false"
               :mask-closable="false"
               @on-resize="handleResize"
               @on-visible-change="handleClose"
               :scrollable="true">
    <div slot="header">
      <div style="display: flex">
        <label style="padding-top: 7px;margin-left: 3px;">{{ model ? model.name:''}}</label>
      </div>

    </div>
    <!--名称-->
    <div class="param">
      <label style="width: 10%"><span style="color: #ff0000;">*</span>名&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
      <el-input v-if="model != null" v-model="labelName" size="small" style="width: 80%;" @change="changeNodeName"></el-input>
    </div>
    <!--label1-->
    <div v-show="!showType[1] && !showType[6]" class="label_line"><span v-show="showType[0]" style="color: red">*</span>
      {{label1}}
    </div>
    <!--语音播报-->
    <div class="param" v-show="!showType[2] && !showType[1]">
      <!--下级菜单语音-->
      <div v-show="(showType[0] || showType[3]) && !showType[4] ">
        <template v-for="(action,index) in actionList">
        <div :key="`action`+index" style="margin-bottom: 10px">
          <!--action-->
          <el-input value="语音文件" size="small" style="width: 40%;" :disabled="true"></el-input>
            <el-select
              size="small"
              style="width: 40%"
              v-model="uaIvrDetail.voiceFile"
              @change="changeFile"
              placeholder="请选择" :clearable="showType[3]">
              <el-option
                v-for="param in fileList"
                :key="param.voiceFileRoute"
                :label="param.voiceFileName"
                :value="param.voiceFileRoute">
              </el-option>
            </el-select>
          </div>
        </template>
        <a @click="addAction" v-show="showType[4]" class="param">+新增动作</a>
      </div>
      <!--语音节点语音-->
      <div v-show="showType[4] || showType[1]">
        <template
          v-for="(action,index) in actionList">
          <div :key="`action`+index" style="margin-bottom: 10px">
            <!--action-->
            <el-select
              v-model="action.type"
              size="small"
              @change="changeAction(index)"
              style="width: 40%"
              placeholder="请选择">
              <el-option
                v-for="item in voiceActions"
                :key="`itemAction`+item.action"
                :label="item.label"
                v-show="('1' == supportAI && item.value != '0' && item.value != '5') || '0' == item.value || '5' == item.value"
                :value="item.value">
              </el-option>
            </el-select>
            <!--file-->
            <el-select
              :disabled="!action.type"
              size="small"
              style="width: 40%"
              v-if="action.type==0"
              v-model="action.value"
              @change="changeFile"
              placeholder="请选择">
              <el-option
                v-for="param in fileList"
                :key="param.voiceFileRoute"
                :label="param.voiceFileName"
                :value="param.id">
              </el-option>
            </el-select>
            <el-select
              :disabled="!action.type"
              size="small"
              style="width: 40%"
              v-if="action.type!=0 && action.type!=3 && action.type!=4 && action.type!=8"
              v-model="action.value"
              @change="changeFile"
              placeholder="请选择">
              <el-option
                v-for="(param,index) in paramList"
                :key="param.detailId+index"
                v-if="param.name != uaIvrDetail.receiver"
                :label="param.label"
                :value="param.label">
              </el-option>
            </el-select>
            <!--word-->
            <el-input size="small" style="width: 40%" v-model="action.value" v-show="action.type==4 || action.type==8 || action.type==2 || action.type==3" placeholder="请输入"></el-input>
            <i class="el-icon-delete" style="cursor: pointer" v-show="showType[4]" @click.prevent="deleteAction(action)"></i>
          </div>
        </template>
        <a @click="addAction" v-show="showType[4]" class="param">+新增动作</a>
      </div>
    </div>
    <!--http 交互-->
    <div class="param" v-show="showType[2]">
      <div class="param">
        <label style="width: 20%;">URL地址：</label>
        <el-input v-model="httpData.url" size="small" style="width: 75%" placeholder="请输入"></el-input>
      </div>
      <div class="param">
        <label style="width:20%;margin-left: 26px">方法：</label>
        <RadioGroup v-model="httpData.httpMethod" type="button"
                    size="small"
                    style="width: 75%"
                    @change="changeMethod">
          <Radio v-for="method in httpMethods" :label="method.value" :key="`method`+method.value">{{method.label}}</Radio>
        </RadioGroup>
      </div>
      <div class="param">
        <label style="width:20%;">返回参数：</label>
        <el-input
          placeholder="多个返回参数用英文逗号隔开"
          v-model="httpData.receiver"
          size="small"
          @change="checkHttpReceive($event)"
          style="width: 75%"></el-input>
      </div>
      <!--请求参数提示-->
      <div class="paramTip">
        <p>Header是请求头</p>
        <p>Query是指请求的参数</p>
      </div>
      <!--tab 表格-->
      <div class="param">
        <Tabs v-model="activeName" @on-click="handleTabClick">
          <!--query tab-->
          <TabPane label="Query" name="Query">
            <div style="margin: 10px 0px">
              <el-table
                :data="httpData.httpVariable"
                border
                tooltip-effect="light"
                style="width: 100%">
                <el-table-column
                  label="名称">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.name" placeholder="参数名"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="值">
                  <template slot-scope="scope">
                    <el-input v-show="'1' == scope.row.type" v-model="scope.row.requestKey" placeholder="参数值"></el-input>
                    <el-select
                      v-show="'1' != scope.row.type"
                      v-model="scope.row.requestKey"
                      size="small"
                      placeholder="请选择"
                      @change="changeQuery($event,scope.row)"
                    >
                      <el-option
                        v-for="(param,index) in paramListHttp"
                        :key="index"
                        v-show="param.detailId != model.ivrDetailId"
                        :label="param.label"
                        :value="param.label">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  width="60"
                  label="操作">
                  <template slot-scope="scope">
                    <el-button icon="el-icon-delete" @click="handleDeleteQuery(scope.$index,scope.row)" circle style="color: #3da8f1"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <a @click="addHttpQuery('1')" class="param">+新增常量</a>
              <a @click="addHttpQuery('2')" class="param">+新增变量</a>
            </div>
          </TabPane>
          <!--header tab-->
          <TabPane label="Header" name="Header">
            <div style="margin: 10px 0px">
              <el-table
                :data="httpData.head"
                border
                tooltip-effect="light"
                style="width: 100%">
                <el-table-column
                  label="名称">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.name" placeholder="参数名"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="值">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.value" placeholder="参数值">
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  width="60"
                  label="操作">
                  <template slot-scope="scope">
                    <el-button icon="el-icon-delete" @click="handleDeleteHeader(scope.$index,scope.row)" circle style="color: #3da8f1"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <a @click="addHttpHeader" class="param">+新增参数</a>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
    <!--label2-->
    <div class="label_line" v-show="!showType[4]">
      {{label2}}
      <Poptip placement="top" transfer width="220" word-wrap :content="tips" trigger="hover">
        <img :src="questionMark" class="tip-img" v-show="!showType[3]"/>
      </Poptip>
    </div>
    <!--判断节点条件分支设置-->
    <div class="param" v-show="showType[1]">
        <div style="padding-bottom: 15px;">
          <label style="width: 30%">选择判断变量</label>
          <el-select
            size="small"
            style="width: 65%"
            v-model="receiverJudge"
            placeholder="请选择所要判断的参数">
            <el-option
              v-for="(param,index) in paramList"
              :key="param.detailId+index"
              :label="param.label"
              :value="param.label">
            </el-option>
          </el-select>
        </div>
        <template v-for="(or,oindex) in judgeList">
          <div :key="`branch`+oindex">
            <label style="width: 30%">如果满足条件</label>
            <el-input v-model="or.name" style="width: 65%" size="small" @input="changeJudgeLabel(or)"></el-input>
            <i class="el-icon-delete" style="cursor: pointer" @click.prevent="deleteCondition(or)"></i>
          </div>
          <div :key="`or`+oindex+`|`" style="background-color: #DCDFE6;padding-top: 10px;margin-top: 10px;padding-bottom: 10px;margin-bottom: 10px">
              <div :key="`and`+oindex" class="param">
                <!--符号-->
                <el-select
                  size="small"
                  style="width: 17%"
                  v-model="or.type"
                  placeholder="请选择">
                  <el-option
                    v-for="symbol in symbols"
                    :key="`symbol`+symbol.id"
                    :title="symbol.label"
                    :label="symbol.label"
                    :value="symbol.value">
                  </el-option>
                </el-select>
                <!--具体的值-->
                <el-input v-model="or.value" size="small" placeholder="请输入具体的值" style="width: 25%"></el-input>
                <el-input value="-->" size="small" style="width: 7%;" :disabled="true"></el-input>
                <el-select
                  size="small"
                  style="width: 23%"
                  v-model="or.nextId"
                  :disabled="true"
                  @change="changeNextScene">
                  <el-option
                    v-for="node in nodes"
                    :key="`node`+node.id"
                    :label="node.label"
                    :value="node.id">
                  </el-option>
                </el-select>
                  <el-radio border size="medium" v-model="or.isDefalut" @change="changeRadio(oindex)" title="所有条件都不满足时所走的节点" name="audio" label="1">默认</el-radio>
              </div>
          </div>
        </template>
    </div>
    <!--Http条件分支设置-->
    <div class="param" v-show="showType[2]" >
      <template v-for="(item,index) in triggerList">
        <div :key="`indent`+index" style="margin-bottom: 10px">
          <el-select
            size="small"
            style="width: 21%"
            v-model="item.funcKey"
            @focus="beforeChanggeKey(item.funcKey)"
            @change="changeIndentForHttp(item,index,$event)"
          >
            <el-option
              v-for="indent in indentListHttp"
              :key="`key`+indent.id"
              :label="indent.name"
              :value="indent.id">
            </el-option>
          </el-select>
          <!--箭头-->
          <el-input value="-->" size="small" style="width: 15%;" :disabled="true"></el-input>
          <!--next scene-->
          <el-select
            size="small"
            style="width: 30%"
            v-model="item.nodeId"
            :disabled="true"
            @change="changeNextScene">
            <el-option
              v-for="node in nodes"
              :key="`node`+node.id"
              :label="node.label"
              :value="node.id">
            </el-option>
          </el-select>
          <!--delete trigger-->
          <i class="el-icon-delete" style="cursor: pointer" @click.prevent="deleteTrigger(item)"></i>
        </div>
      </template>
    </div>
    <!--按键识别-->
    <div class="param" v-show="showType[0] && !showType[4]">
      <template v-for="(item,index) in triggerList">
        <div :key="`indent`+index" style="margin-bottom: 10px">
            <el-select
              size="small"
              style="width: 25%;padding-right: 1%"
              v-model="item.funcKey"
              @change="changeIndent(item,index,$event)"
              @focus="beforeChanggeKey(item.funcKey)"
              @visible-change="updateHasIndent"
            >
              <el-option
                v-for="indent in indentList"
                :key="`key`+indent.id"
                :label="indent.name"
                :value="indent.id"
              >
              </el-option>
            </el-select>
            <!--箭头-->
            <el-input value="-->" size="small" style="width: 20%;padding-right: 1%" :disabled="true"></el-input>
            <!--next scene-->
            <el-select
              size="small"
              style="width: 35%;padding-right: 1%"
              v-model="item.nodeId"
              :disabled="true"
              @change="changeNextScene">
              <el-option
                v-for="node in nodes"
                :key="`node`+node.id"
                :label="node.label"
                :value="node.id">
              </el-option>
            </el-select>
            <!--delete trigger-->
            <i class="el-icon-delete" style="cursor: pointer;padding-right: 2%" @click.prevent="deleteTrigger(item)"></i>
        </div>
      </template>
      <!--新增trigger-->
      <!--自动添加-->
      <!--<a @click="addTrigger" :disabled="true" class="param">+新增触发条件</a>-->
    </div>
    <!--子节点转接动作-->
    <div class="param" v-show="(showType[3] && !showType[5]) || showType[6]">
      <div class="input_overall" v-show="!showType[6]">
        <div class="font_style_set">业务类型:</div>
        <Select v-model="uaIvrDetail.businessType">
          <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
          <div slot="content">
            多个号码填写时以“,”作为间隔<br/>
            顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
            记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
            共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
            技能组：将呼入号码转接至所选技能组中<br/>
          </div>
        </Tooltip>
      </div>
      <div class="input_overall" v-if="uaIvrDetail.businessType!='9' && !showType[6]">
        <div class="font_style_set"><span style="color: red">*</span>号码:</div>
        <Input v-model="uaIvrDetail.transNumber" placeholder="号码之间用英文逗号相隔"/>
        <Tooltip class="tips_font" placement="top" content="填分机号,外线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
      </div>
      <div class="input_overall" v-if="uaIvrDetail.businessType=='9' && !showType[6]">
        <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
        <Select v-model="uaIvrDetail.transNumber">
          <OptionGroup label="普通技能组">
            <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
          </OptionGroup>
          <OptionGroup label="AI技能组">
            <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
          </OptionGroup>
        </Select>
      </div>
      <div class="input_overall">
        <div class="font_style_set">可选设置:</div>
        <Checkbox v-model="highSet">高级设置</Checkbox>
        <Checkbox v-model="uaIvrDetail.isSendSms" v-if="highSet">发送短信</Checkbox>
        <Checkbox v-model="uaIvrDetail.isSmsGather" v-if="highSet">按键采集</Checkbox>
      </div>
      <div class="input_overall" v-if="highSet && !showType[6]">
        <div class="font_style_set">开始转接时间(秒):</div>
        <Input v-model="uaIvrDetail.timeout"  @on-blur="checkLength" placeholder="开始转接时间"/>
        <Tooltip class="tips_font" placement="top" content="0-60秒"><img :src="questionMark"/></Tooltip>
      </div>
      <div class="input_overall" v-if="highSet && uaIvrDetail.isSmsGather">
        <div class="font_style_set">按键描述:</div>
        <Input v-model="uaIvrDetail.smsButtonDesc" placeholder="请输入按键描述"/>
      </div>
      <div class="input_overall" v-if="highSet && uaIvrDetail.isSmsGather && showType[6]">
        <div class="font_style_set">按键长度:</div>
        <Input v-model="uaIvrDetail.gatherLength" @on-blur="checkPhoneNumber" placeholder="请输入按键长度"/>
      </div>
      <div class="input_overall" v-show="highSet && uaIvrDetail.isSmsGather && showType[6]">
        <div class="font_style_set">按键语音类型:</div>
        <Select v-model="uaIvrDetail.gatherVoiceType">
          <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <el-select
          size="small"
          style="width: 30%;padding-left: 10px;"
          v-model="uaIvrDetail.gatherVoiceFile"
          placeholder="请选择">
          <el-option
            v-for="param in fileList"
            :key="`param`+param.id"
            :label="param.voiceFileName"
            :value="param.voiceFileRoute">
          </el-option>
        </el-select>
      </div>
      <div class="input_overall" v-if="highSet && uaIvrDetail.isSendSms">
        <div class="font_style_set">短信内容:</div>
        <Input v-model="uaIvrDetail.smsContent" :autosize="autoSize" type="textarea"/>
        <Tooltip class="tips_font" placement="top" content="内容允许空格，但不允许换行"><img :src="questionMark"/></Tooltip>
      </div>
    </div>
    <!--label3-->
    <div class="label_line" v-show="!showType[1] && !showType[3] && !showType[2]">
      {{label3}}
    </div>
    <!--顶级下级菜单节点高级设置-->
    <div class="param" v-show="showType[0] && showType[5]">
      <div style="width: 100%;">
        <Checkbox v-model="highSet">高级设置</Checkbox>
        <Checkbox v-model="uaIvrDetail.isCallExtension" v-if="highSet">允许拨打分机</Checkbox>
        <Checkbox v-model="uaIvrDetail.isTimeoutBusiness" v-if="highSet">启用超时业务</Checkbox>
      </div>
      <div style="width: 100%;">
        <div class="single_input" v-if="highSet">
          <div class="font_style_set">短欢迎词类型:</div>
          <Select v-model="uaIvrDetail.shortVoiceType" c>
            <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <el-select
            size="small"
            style="width: 30%"
            v-model="uaIvrDetail.shortVoiceFile"
            placeholder="请选择" clearable>
            <el-option
              v-for="param in fileList"
              :key="`param`+param.id"
              :label="param.voiceFileName"
              :value="param.voiceFileRoute">
            </el-option>
          </el-select>
        </div>
        <div class="single_input" v-if="highSet">
          <div class="font_style_set">无效提示音类型:</div>
          <Select v-model="uaIvrDetail.invalidVoiceType">
            <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <el-select
            size="small"
            v-model="uaIvrDetail.invalidVoiceFile"
            style="width: 30%"
            placeholder="请选择" clearable>
            <el-option
              v-for="param in fileList"
              :key="`param`+param.id"
              :label="param.voiceFileName"
              :value="param.voiceFileRoute">
            </el-option>
          </el-select>
        </div>
        <div class="single_input" v-if="highSet">
          <div class="font_style_set">超过重复次数语音类型:</div>
          <Select v-model="uaIvrDetail.exceedVoiceType">
            <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <el-select
            size="small"
            v-model="uaIvrDetail.exceedVoiceFile"
            style="width: 30%"
            placeholder="请选择" clearable>
            <el-option
              v-for="param in fileList"
              :key="param.voiceFileRoute"
              :label="param.voiceFileName"
              :value="param.voiceFileRoute">
            </el-option>
          </el-select>
        </div>
        <div class="single_input" v-if="highSet">
          <div class="font_style_set">记忆功能:</div>
          <RadioGroup v-model="uaIvrDetail.memoryType" type="button">
            <Radio v-for="(option, index) in memoryList" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
        <div class="single_input" v-if="highSet && uaIvrDetail.memoryType!='0'">
          <div class="font_style_set"><span style="color: red">*</span>记忆时间(分钟数):</div>
          <Input v-model="uaIvrDetail.memoryDuration" placeholder="请输入记忆时间(分钟数)" @on-blur="checkPhoneNumber"/>
          <Tooltip class="tips_font" placement="top" content="1-50000"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="single_input" v-if="highSet && !uaIvrDetail.isTimeoutBusiness">
          <div class="font_style_set"><span style="color: red">*</span>重复提示间隔(秒):</div>
          <Input v-model="uaIvrDetail.promptInterval" placeholder="请输入重复提示间隔(秒)"/>
        </div>
        <div class="single_input" v-if="highSet && !uaIvrDetail.isTimeoutBusiness">
          <div class="font_style_set"><span style="color: red">*</span>重复提示次数:</div>
          <Input v-model="uaIvrDetail.promptCount" placeholder="请输入重复提示次数"/>
        </div>
        <div class="single_input" v-if="highSet && uaIvrDetail.isTimeoutBusiness">
          <div class="font_style_set">超时时间(秒):</div>
          <Input v-model="uaIvrDetail.timeout" @on-blur="checkLength"/>
          <Tooltip class="tips_font" placement="top" content="(0-60)*"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="single_input" v-if="highSet && uaIvrDetail.isTimeoutBusiness">
          <div class="font_style_set">业务类型:</div>
          <Select v-model="uaIvrDetail.businessType">
            <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
          <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
            <div slot="content">
              多个号码填写时以“,”作为间隔<br/>
              顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
              记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
              共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
              技能组：将呼入号码转接至所选技能组中<br/>
            </div>
          </Tooltip>
        </div>
        <div class="single_input" v-if="highSet && uaIvrDetail.isTimeoutBusiness && uaIvrDetail.businessType!='9'">
          <div class="font_style_set"><span style="color: red">*</span>号码:</div>
          <Input v-model="uaIvrDetail.transNumber" placeholder="号码之间用英文逗号相隔" :autosize="autoSize" type="textarea"/>
          <Tooltip class="tips_font" placement="top" content="填分机号,热线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
        </div>
        <div class="single_input" v-if="highSet && uaIvrDetail.isTimeoutBusiness && uaIvrDetail.businessType=='9'">
          <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
          <Select v-model="uaIvrDetail.transNumber">
            <OptionGroup label="普通技能组">
              <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
            </OptionGroup>
            <OptionGroup label="AI技能组">
              <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
            </OptionGroup>
          </Select>
        </div>
      </div>
    </div>
    <!--顶级转接节点高级设置-->
    <div class="param" v-show="showType[3] && showType[5]">
      <div class="input_overall">
        <div class="font_style_set">开始转接时间(秒):</div>
        <Input v-model="uaIvrDetail.timeout"  @on-blur="checkLength" placeholder="开始转接时间"/>
        <Tooltip class="tips_font" placement="top" content="0-60秒"><img :src="questionMark"/></Tooltip>
      </div>
      <div class="input_overall">
        <div class="font_style_set">业务类型:</div>
        <Select v-model="uaIvrDetail.businessType">
          <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
          <div slot="content">
            多个号码填写时以“,”作为间隔<br/>
            顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
            记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
            共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
            技能组：将呼入号码转接至所选技能组中<br/>
          </div>
        </Tooltip>
      </div>
      <div class="input_overall" v-if="uaIvrDetail.businessType!='9'">
        <div class="font_style_set"><span style="color: red">*</span>号码:</div>
        <Input v-model="uaIvrDetail.transNumber" placeholder="号码之间用英文逗号相隔" :autosize="autoSize" type="textarea"/>
        <Tooltip class="tips_font" placement="top" content="填分机号,外线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
      </div>
      <div class="input_overall" v-if="uaIvrDetail.businessType=='9'">
      <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
      <Select v-model="uaIvrDetail.transNumber">
        <OptionGroup label="普通技能组">
          <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
        </OptionGroup>
        <OptionGroup label="AI技能组">
          <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
        </OptionGroup>
      </Select>
    </div>
    </div>
    <!--下级菜单高级设置-->
    <div class="param" v-show="showType[0] && !showType[5] && !showType[4]">
      <div class="input_overall">
        <div class="font_style_set">可选设置:</div>
        <Checkbox v-model="highSet">高级设置</Checkbox>
        <Checkbox v-model="uaIvrDetail.isSendSms" v-if="highSet">发送短信</Checkbox>
        <Checkbox v-model="uaIvrDetail.isSmsGather" v-if="highSet">按键采集</Checkbox>
        <Checkbox v-model="uaIvrDetail.isCallExtension" v-if="highSet">允许拨打分机</Checkbox>
        <Checkbox v-model="uaIvrDetail.isTimeoutBusiness" v-if="highSet">启用超时业务</Checkbox>
      </div>
      <div class="input_overall" v-if="highSet && !uaIvrDetail.isTimeoutBusiness">
        <div class="font_style_set"><span style="color: red">*</span>重复提示间隔(秒):</div>
        <Input v-model="uaIvrDetail.promptInterval" placeholder="请输入重复提示间隔(秒)"/>
      </div>
      <div class="input_overall" v-if="highSet && !uaIvrDetail.isTimeoutBusiness">
        <div class="font_style_set"><span style="color: red">*</span>重复提示次数:</div>
        <Input v-model="uaIvrDetail.promptCount" placeholder="请输入重复提示间隔次数"/>
      </div>
      <div class="input_overall" v-if="highSet && uaIvrDetail.isTimeoutBusiness">
        <div class="font_style_set">超时时间(秒):</div>
        <Input v-model="uaIvrDetail.timeout"  @on-blur="checkLength"/>
        <Tooltip class="tips_font" placement="top" content="(0-60)*"><img :src="questionMark"/></Tooltip>
      </div>
      <div class="input_overall" v-if="highSet && uaIvrDetail.isTimeoutBusiness">
        <div class="font_style_set">业务类型:</div>
        <Select v-model="uaIvrDetail.businessType">
          <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
          <div slot="content">
            多个号码填写时以“,”作为间隔<br/>
            顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
            记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
            共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
            技能组：将呼入号码转接至所选技能组中<br/>
          </div>
        </Tooltip>
      </div>
      <div class="input_overall" v-if="(highSet && uaIvrDetail.isTimeoutBusiness && uaIvrDetail.businessType!='9')">
        <div class="font_style_set"><span style="color: red">*</span>号码:</div>
        <Input v-model="uaIvrDetail.transNumber" placeholder="号码之间用英文逗号相隔"/>
        <Tooltip class="tips_font" placement="top" content="填分机号,外线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
      </div>
      <div class="input_overall" v-if="(highSet && uaIvrDetail.isTimeoutBusiness && uaIvrDetail.businessType=='9')">
        <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
        <Select v-model="uaIvrDetail.transNumber">
          <OptionGroup label="普通技能组">
            <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
          </OptionGroup>
          <OptionGroup label="AI技能组">
            <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
          </OptionGroup>
        </Select>
      </div>
      <div class="input_overall" v-if="highSet && uaIvrDetail.isSmsGather">
        <div class="font_style_set">按键描述:</div>
        <Input v-model="uaIvrDetail.smsButtonDesc" placeholder="请输入按键描述"/>
      </div>
      <div class="input_overall" v-if="highSet && uaIvrDetail.isSmsGather">
        <div class="font_style_set">按键长度:</div>
        <Input v-model="uaIvrDetail.gatherLength" @on-blur="checkPhoneNumber" placeholder="请输入按键长度"/>
      </div>
      <div class="input_overall" v-show="highSet && uaIvrDetail.isSmsGather">
        <div class="font_style_set">按键语音类型:</div>
        <Select v-model="uaIvrDetail.gatherVoiceType">
          <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <el-select
          size="small"
          style="width: 30%;padding-left: 10px;"
          v-model="uaIvrDetail.gatherVoiceFile"
          placeholder="请选择" clearable>
          <el-option
            v-for="param in fileList"
            :key="`param`+param.id"
            :label="param.voiceFileName"
            :value="param.voiceFileRoute">
          </el-option>
        </el-select>
      </div>
      <div class="input_overall" v-if="highSet && uaIvrDetail.isSendSms">
        <div class="font_style_set">短信内容:</div>
        <Input v-model="uaIvrDetail.smsContent" :autosize="autoSize" type="textarea"/>
        <Tooltip class="tips_font" placement="top" content="内容允许空格，但不允许换行"><img :src="questionMark"/></Tooltip>
      </div>
    </div>
    <div class="param" v-show="showType[4]">
      <div style="width: 100%;">
        <Checkbox v-model="uaIvrDetail.isReceiver">允许收号</Checkbox>
        <el-input size="small" @focus="beforeChangge" @change="checkHttpReceive($event)" v-show="uaIvrDetail.isReceiver" style="width: 150px" v-model="uaIvrDetail.receiver" placeholder="请输入收号变量名"></el-input>
      </div>
    </div>
    <!--footer 语音交互显示-->
    <div slot="footer" v-if="showType[2]">
      <div style="display: flow">
<!--        <div style="width: 20%;float: left">-->
<!--          <el-checkbox v-model="scene.rsInterrupt" :true-label="1" :false-label="0" style="margin-top: 5px">可打断</el-checkbox>-->
<!--        </div>-->
        <div style="width: 60%;float: left">
          超时（秒）：
          <el-input size="small" style="width: 150px" type="number" v-model="httpData.timeout" placeholder="请输入超时时间(秒)"></el-input>
        </div>
      </div>
    </div>
    <playMusicPop  @closeRecordfile="closeRecordfile" :showRecordFile="showRecordFile" :recordFile="recordFile"></playMusicPop>
    <!--dialog-->
  </drag-drawer>
</template>

<script>
    import DragDrawer from "@/components/flow/components/dragDrawer/drag-drawer";
    import {publicFunClass} from "@/components/js/PublicFunClass.js"
    import {uniqueId} from "../../../util";
    import eventBus from "../../../util/eventBus";
    import playMusicPop from '@/components/statisticsReportForm/detailedReportForm/PlayMusicPop.vue'

    export default {
      name: "IvrNodeDrawer",
      components: {DragDrawer,playMusicPop},
      props: ['nodeShow', 'flowId','model','nodeList','paramListForAll','httpParamList'],
      mixins: [publicFunClass],
      data() {
        return {
          labelName:'',
          isDefalut:'',
          receiverJudge:'',
          judgeList:[],
          showRecordFile:false,
          uaIvrDetail : {
            isReceiver:false,
            receiver:'',
            id : "",
            ivrId : "",
            pid : "",
            ivrLevel : "0",
            funcKey : "",
            ivrType : "",
            ivrTypeValue : "",
            transNumber : "",
            voiceFile : "",
            promptInterval : "",
            promptCount : "",
            isCallExtension : false,
            descr : "",
            isTimeoutBusiness : false,
            businessType : "9",
            timeout : "20",
            voiceText : "",
            voiceType : "1",
            transInterval : "0",
            isSendSms : false,
            isSmsGather : false,
            smsButtonDesc : "",
            shortVoiceType : "1",
            shortVoiceFile : "",
            shortVoiceText : "",
            invalidVoiceType : "1",
            invalidVoiceFile : "",
            invalidVoiceText : "",
            exceedVoiceType : "1",
            exceedVoiceFile : "",
            exceedVoiceText : "",
            gatherVoiceType : "1",
            gatherVoiceText : "",
            gatherVoiceFile : "",
            gatherLength : "1",
            transferFlag : "0",
            transferUrl : "",
            transferText : "",
            transferFile : "",
            transferLength : "0",
            smsContent : "",
            memoryType:'0',
            memoryDuration:'',
          },
          elementList:[],
          autoSize:true,
          businessList:[{id:'1', name:"顺振"},{id:'2', name:"记忆轮循"},{id:'3', name:"共振"},{id:'9', name:"技能组"}],
          queueList2:[],
          memoryList:[{id:'0', name:"关闭"},{id:'1', name:"呼出未接记录记忆"},{id:'2', name:"全部记录记忆"}],
          welCodeList:[{id:'1', name:"语音文件"}],
          highSet:false,
          width: 700,
          minWidth: 550,
          placement: 'right',
          showDrawer: false,
          questionMark:require('../../../assets/image/homeAsk.png'),
          screenHeight:{height:''},
          icon:undefined,
          label:undefined,
          label1:'语音文件设置',
          label2:'按键设置',
          tips:'连接节点，自动添加按键识别',
          label3:'信息采集槽位',
          actionList:[],
          endActionList:[{id:'',rsId:this.sceneId,eaType:1,eaValue:'',actionParams:[]}],
          voiceActions:[
            {action:'playFile',label:'语音文件',value:'0'},
            {action:'playNum',label:'播放数字',value:'3'},
            {action:'playN',label:'播放数目',value:'4'},
            {action:'playTTSN',label:'TTS内容',value:'8'},
            {action:'playFileEle',label:'语音变量',value:'5'},
            {action:'playNumB',label:'数字变量',value:'6'},
            {action:'playNB',label:'数目变量',value:'7'},
            {action:'playTTSB',label:'TTS变量',value:'9'},
          ],//语音交互动作集合
          fileList:[],//语音文件集合
          IVRList:[],//ivr号码集合
          queueList:[],//队列集合
          triggerList:[],//触发数据
          triggers:[
            {type:'indent',label:'按键',value:1},
          ],//触发方式
          indentList:[{id:'0', name:"按键0"},{id:'1', name:"按键1"},{id:'2', name:"按键2"},{id:'3', name:"按键3"},{id:'4', name:"按键4"},{id:'5', name:"按键5"},{id:'6', name:"按键6"},{id:'7', name:"按键7"},{id:'8', name:"按键8"},{id:'9', name:"按键9"}],//该流程下的全部按键,{id:'*', name:"按键*"}
          indentListHttp:[{id:'success', name:"成功"},{id:'fail', name:"失败"}],
          //按键下拉时更新
          nodeIndentList:[],//该节点所持有的按键
          nodes:[],
          paramList:[],//参数列表
          paramListHttp:[],
          indentId:'',//参数按键
          httpMethods:[
            {id:"0",value:"0",label:'GET'},
            {id:"1",value:"1",label:'POST'}
          ],
          httpData:{id:'',timeout:10,httpMethod:'0',url:'',failNextId:'',receiver:'',head:[],httpVariable:[]},
          activeName:'Query',//当前激活的tab页
          symbols:[
            {id:'1',label:'==',value:'3'},
            {id:'2',label:'>=',value:'4'},
            {id:'3',label:'<=',value:'5'},
            {id:'4',label:'>',value:'1'},
            {id:'5',label:'<',value:'2'},
          ],
          othersNextSceneId: '',
          showType:[true,false,false,false,false,false,false],
          judgeElementList: {receiver:'',judgeVariable:[]},//判断条件设置数据
          showDialog:false,
          scene:{isTop:'0',ivrDetailId:'',id:'',rsType:'1',label:'',ivrId:''},
          sceneId:'',
          //删除的数据
          deleteActions:[],
          deleteRecognizes:[],
          deleteAnds:[],
          deleteOrs:[],
          deleteBranches:[],
          deleteHeaders:[],
          deleteQueries:[],
          format:['mp3','wav'],
          recordFile:'',
          receiveParam:'',
          closeFlag:true,
          keyParam:'',
          supportAI:JSON.parse(localStorage.getItem("supportAI")),
        }
      },
      methods: {
        changeRadio(oindex){
          for (let i=0;i<this.judgeList.length;i++){
            this.judgeList[i].isDefalut = '0';
          }
          this.judgeList[oindex].isDefalut = '1';
        },
        checkHttpReceive(num){
          let numList=num.split(",");
          let detailId = this.model.ivrDetailId;
          let newParamList = [];
          if(null != this.paramList && this.paramList.length > 0){
            newParamList = JSON.parse(JSON.stringify(this.paramList));
            let j = newParamList.length;
            while(j--) {
              if(newParamList[j].detailId === detailId) {
                newParamList.splice(j, 1);
              }
            }
          }
          this.paramList = JSON.parse(JSON.stringify(newParamList));
          this.paramListHttp = JSON.parse(JSON.stringify(newParamList));
          for (let i=0;i<numList.length;i++){
            if(numList[i]){
              let value = {label:numList[i]+"~"+this.model.label,name:numList[i],type:'2',detailId:detailId};
              this.paramList.push(value);
              this.paramListHttp.push(value);
            }
          }
          let newList = [{label:'客户呼叫ID',name:'customer_uuid',type:'0',detailId:''},{label:'客户号码',name:'customer_number',type:'0',detailId:''},{label:'接入号',name:'callcenter_number',type:'0',detailId:''}];
          for (let i=0;i<3;i++){
            this.paramListHttp.push(newList[i]);
          }
        },
        beforeChanggeKey(num){
          this.keyParam = num;
        },
        beforeChangge(){
          this.receiveParam = this.uaIvrDetail.receiver;
        },
        checkPhoneNumber:function(event){
          let name=event.currentTarget.name;
          let placeholder = event.currentTarget.placeholder;
          let value=event.currentTarget.value;
          let reg=/^[0-9]*$/;
          if(!reg.test(value)){
            this.$Modal.info({
              title:'提示',
              content:name+"只能输入数字"
            });
            event.currentTarget.value=event.currentTarget.value.replace(/[^\d]/g,'');
            if( placeholder.indexOf('按键长度') != -1 && !event.currentTarget.value){
              event.currentTarget.value='1';
            }
            return false;
          }
          if( placeholder.indexOf('按键长度') != -1 && '0' == value){
              this.$Modal.info({
                title:'提示',
                content:"按键长度不能设置为0"
              });
              event.currentTarget.value='1';
              return false;
          }
        },
        checkLength:function(event){
          let name=event.currentTarget.name;
          let value=event.currentTarget.value;
          let reg=/^[0-9]*$/;
          if(!reg.test(value) || value > 60 || !value){
            this.$Modal.info({
              title:'提示',
              content:name+"只能输入0-60的数字"
            });
            event.currentTarget.value=0;
            return false;
          }
        },
        //播放回调函数
        closeRecordfile:function(){
          this.showRecordFile=false;
        },
        searchVoiceFile() {
          let param={
            journalType:"系统管理=>CTI配置=>语音文件查询",
            menuId:"null",
          };
          this.$http.post('voiceFile/toIndex.json',param).then(res=>{
            let response = res.data
            if (response.flag != '666') {
              that.$alert(response.msg,'提示',{
                confirmButtonText: '确定'
              })
              return false
            }
            if(response.obj.list.content){
              this.fileList = response.obj.list.content;
            }
          })
        },
        async initSelectData(flowId) {
          //初始化所有的下拉等数据
          //语音文件
          if(this.model.nodeData){
            if(this.model.nodeData.uaIvrDetail){
              this.uaIvrDetail = this.model.nodeData.uaIvrDetail;
            }else{
              this.uaIvrDetail = {
                isReceiver:false,
                receiver:'',
                  id : "",
                  ivrId : "",
                  pid : "",
                  ivrLevel : "0",
                  funcKey : "",
                  ivrType : "",
                  ivrTypeValue : "",
                  transNumber : "",
                  voiceFile : "",
                  promptInterval : "",
                  promptCount : "",
                  isCallExtension : false,
                  descr : "",
                  isTimeoutBusiness : false,
                  businessType : "9",
                  timeout : "20",
                  voiceText : "",
                  voiceType : "1",
                  transInterval : "0",
                  isSendSms : false,
                  isSmsGather : false,
                  smsButtonDesc : "",
                  shortVoiceType : "1",
                  shortVoiceFile : "",
                  shortVoiceText : "",
                  invalidVoiceType : "1",
                  invalidVoiceFile : "",
                  invalidVoiceText : "",
                  exceedVoiceType : "1",
                  exceedVoiceFile : "",
                  exceedVoiceText : "",
                  gatherVoiceType : "1",
                  gatherVoiceText : "",
                  gatherVoiceFile : "",
                  gatherLength : "1",
                  transferFlag : "0",
                  transferUrl : "",
                  transferText : "",
                  transferFile : "",
                  transferLength : "0",
                  smsContent : "",
                  memoryType:'0',
                  memoryDuration:'',
              };
            }
            if(this.model.nodeData.judgeElementList){
              let value = this.model.nodeData.judgeElementList.judgeVariable;
              if(null != value && value.length > 0){
                this.judgeList = value;
              }
            }
          }
        },
        generatorData(data) {
          let that = this;
          //基本数据
          this.scene.id = data.id;
          this.scene.ivrDetailId = data.ivrDetailId;
          this.scene.rsType = data.rsType;
          this.scene.isTop = data.isTop;
          this.scene.ivrId = data.ivrId;
          this.scene.label = data.label;
          if(this.model.nodeData){
            if(this.model.nodeData.uaIvrDetail){
              this.uaIvrDetail = this.model.nodeData.uaIvrDetail;
            }
          }
          switch (this.scene.rsType+'') {
            case '1':
              //识别
              let recognizes = [];
              if(data.nodeData.recognizes){
                recognizes = data.nodeData.recognizes;
              }
              let recArr = []
              if (recognizes.length > 0) {
                this.indentId = recognizes[0].funcKey
                recognizes.forEach(rec=>{
                  let json = {}
                  json.id = rec.edgeId
                  if(!rec.edgeId){
                    json.id = rec.id
                  }
                  json.rsId = rec.funcKey
                  json.trigger = 1
                  json.symbol = '=='
                  json.funcKey = rec.funcKey
                  json.nodeId = rec.nodeId
                  recArr.push(json)
                })
                this.triggerList = recArr

                this.nodeIndentList = []
                this.triggerList.forEach(t=>{
                  this.indentList.forEach(i=>{
                    if (t.funcKey === i.id) {
                      let json = {}
                      json.id = t.funcKey
                      json.name = i.name
                      this.nodeIndentList.push(json)
                    }
                  })
                })
              }
              break;
            case '7':
              let httpDate = {httpMethod:'0',url:'',timeout:10,failNextId:'',receiver:'',head:[],httpVariable:[]};
              if(data.nodeData.nodeHttpList){
                if(data.nodeData.nodeHttpList.url){
                  httpDate = data.nodeData.nodeHttpList;
                  if(httpDate.head && 'string' === typeof httpDate.head){
                    let newList = [];
                    let newParam = JSON.parse(httpDate.head);
                    for (let item in newParam){
                      let param = {
                        name:item,
                        value:newParam[item],
                      };
                      newList.push(param);
                    }
                    httpDate.head = newList;
                  }else if(!httpDate.head){
                    httpDate.head = [];
                  }
                  if(httpDate.httpVariable){
                    for(let c=0;c<httpDate.httpVariable.length;c++){
                      if('0' == httpDate.httpVariable[c].type){
                        let newValueOne = '接入号';
                        if('customer_uuid' == httpDate.httpVariable[c].requestKey || '客户呼叫ID' == httpDate.httpVariable[c].requestKey){
                          newValueOne = "客户呼叫ID";
                        }else if('customer_number' == httpDate.httpVariable[c].requestKey || '客户号码' == httpDate.httpVariable[c].requestKey){
                          newValueOne = "客户号码";
                        }
                        httpDate.httpVariable[c].requestKey = newValueOne;
                      }
                    }
                  }
                }
              }
              that.httpData = httpDate;
              let recognizesHttp = [];
              if(null == data.nodeData.recognizes || data.nodeData.recognizes.length == 0){
                    if(httpDate.successNextId){
                      let newValue = {edgeId: httpDate.successEdgeId,funcKey:'success',id: '',isNode: "0",isTop: "0",nodeId: httpDate.successTargetId,purposeId: "",rsId: httpDate.successSourceId,symbol: "==",trigger: 1};
                      data.nodeData.recognizes.push(newValue);
                      newValue = {edgeId: httpDate.failEdgeId,funcKey:'fail',id: '',isNode: "0",isTop: "0",nodeId: httpDate.failTargetId,purposeId: "",rsId: httpDate.failSourceId,symbol: "==",trigger: 1};
                      data.nodeData.recognizes.push(newValue);
                    }
                }
              recognizesHttp = data.nodeData.recognizes;
              let recArrHttp = []
              if (null != recognizesHttp && recognizesHttp.length > 0) {
                this.indentId = recognizesHttp[0].funcKey
                recognizesHttp.forEach(rec => {
                  let json = {}
                  json.id = rec.edgeId
                  json.rsId = rec.funcKey
                  json.trigger = 1
                  json.symbol = '=='
                  json.funcKey = rec.funcKey
                  json.nodeId = rec.nodeId
                  recArrHttp.push(json)
                })
                this.triggerList = recArrHttp
              }
              break;
            case '8':
              let judgeActions = {};
              if(data.nodeData.judgeElementList){
                judgeActions = data.nodeData.judgeElementList;
              }
              this.judgeElementList = judgeActions;
              this.judgeList = judgeActions.judgeVariable;
              this.receiverJudge = judgeActions.receiver;
              break
            case '5':
              let actionArr = [];
              let actions = [];
              if(data.nodeData.promptElementList){
                actions = data.nodeData.promptElementList;
              }
              if (actions.length > 0) {
                actions.forEach(action=>{
                  action.actionParams = that.elementList;
                  actionArr.push(action);
                })
                that.actionList = actionArr;
              }
              break
          }
        },
        generatorUpdateData() {
          //当属性框改变显示的时候，或者节点变化的时候，把该个节点属性提交到父组件存储
          //生成更新的数据
          let json = {}
          if (this.scene) {
            //基本数据
            json.scene = this.scene
            if(this.model.nodeData.uaIvrDetail){
              json.uaIvrDetail = this.model.nodeData.uaIvrDetail;
            }else{
              json.uaIvrDetail = this.uaIvrDetail;
            }
            json.uaIvrDetail.highSet = this.highSet;
            switch (this.scene.rsType+'') {
              case "1":
                json.recognizes = this.triggerList
                break
              case '5':
                this.$set(this.judgeElementList,'receiver',this.receiverJudge)
                json.judgeElementList = this.judgeElementList;
                break
              case '2':
                json.promptElementList = this.actionList;
                break
              case '3':
                json.nodeHttpList = this.httpData;
                json.recognizes = this.triggerList
                break
              case '4':
                break
            }
          }
          this.$emit('updateData',json)
        },
        resetData() {
          this.highSet = false;
          this.uaIvrDetail = {
            id : "",
            ivrId : "",
            pid : "",
            ivrLevel : "0",
            funcKey : "",
            ivrType : "",
            ivrTypeValue : "",
            transNumber : "",
            voiceFile : "",
            promptInterval : "",
            promptCount : "",
            isCallExtension : false,
            descr : "",
            isTimeoutBusiness : false,
            businessType : "9",
            timeout : "20",
            voiceText : "",
            voiceType : "1",
            transInterval : "0",
            isSendSms : false,
            isSmsGather : false,
            smsButtonDesc : "",
            shortVoiceType : "1",
            shortVoiceFile : "",
            shortVoiceText : "",
            invalidVoiceType : "1",
            invalidVoiceFile : "",
            invalidVoiceText : "",
            exceedVoiceType : "1",
            exceedVoiceFile : "",
            exceedVoiceText : "",
            gatherVoiceType : "1",
            gatherVoiceText : "",
            gatherVoiceFile : "",
            gatherLength : "1",
            transferFlag : "0",
            transferUrl : "",
            transferText : "",
            transferFile : "",
            transferLength : "0",
            smsContent : "",
            memoryType:'0',
            memoryDuration:'',
          },
          this.httpData = {id:'',httpMethod:'0',timeout:10,url:'',othersNextSceneId:'',received:'',receivedName:'',head:[],httpVariable:[]}
          this.actionList = []
          this.endActionList = [{id:'',rsId:this.sceneId,eaType:1,eaValue:'',actionParams:[]}]
          this.triggerList = []
          this.judgeElementList = {receiver:'',judgeVariable:[]},//,HTTP 条件设置数据
          //删除数据集合
          this.scene={isTop:'0',ivrDetailId:'',id:'',rsType:'1',label:'',ivrId:''};
          this.deleteActions = []
          this.deleteRecognizes = []
          this.deleteOrs = []
          this.deleteAnds = []
          this.deleteBranches = []
          this.deleteHeaders = []
          this.deleteQueries = []
          this.indentId = ''
          this.sceneId = ''
        },
        updateHasIndent(val) {
          let that = this
          if (!val) {
            if (this.triggerList.length <= 0) {
              this.nodeIndentList = [];
              this.indentId = ''
            } else {
              if (this.indentList.length > 0) {
                this.nodeIndentList = []
                this.triggerList.forEach(t=>{
                  this.indentList.forEach(i=>{
                    if (t.funcKey === i.id) {
                      let json = {}
                      json.id = t.funcKey
                      json.name = i.name
                      this.nodeIndentList.push(json)
                    }
                  })
                });
                let id = ''
                if (this.nodeIndentList.length > 0) {
                  this.nodeIndentList.forEach(n=>{
                    if (n.id === that.indentId) {
                      id = that.indentId
                    }
                  })
                }
                this.indentId = id
              }
            }
          }
        },
        handleResize(event) {
          const {atMin} = event
        },
        handleClose(val) {
          if (!val) {
            switch (this.scene.rsType+'') {
              case '1':

                break;
              case '2':

                break;
              case '7':

                break;
              case '8':

                break;
              case '5':

                break;
            }
            this.generatorUpdateData()
            this.$emit('closeNodeDrawer', true)
          }
        },
        changeNodeName(value) {
          if(value){
            this.$emit('updateNodeLabel',this.model.id,value)
            this.scene.rsName = value
          }else{
            this.labelName = this.model.label;
          }
        },
        changeAction(index) {
          //修改参数为下标行号
          let action = this.actionList[index].rsaType
          this.actionList[index].rsaPlayFile = '';
          this.actionList[index].value = '';
        },
        changeFile(file) {
        },
        addAction() {
          if(null != this.actionList && this.actionList.length > 0){
            this.actionList.push({id:'',seq:parseInt(this.actionList[this.actionList.length-1].seq) + 1,rsId:this.sceneId,rsaType:'1',rsaPlayFile:'',rsaPlayTxt: '',value:'',type:'',key:Date.now()});
          }else{
            this.actionList.push({id:'',seq:0,rsId:this.sceneId,rsaType:'1',rsaPlayFile:'',rsaPlayTxt: '',value:'',type:'',key:Date.now()});
          }
        },
        deleteAction(action) {
          let index = this.actionList.indexOf(action)
          if (index !== -1) {
            if (action.id) {
              this.deleteActions.push(action.id+'');
            }
            this.actionList.splice(index, 1)
          }
        },
        deleteEndAction(action) {
          let index = this.endActionList.indexOf(action)
          if (index !== -1) {
            if (action.id) {
              this.deleteActions.push(action.id+'')
            }
            this.endActionList.splice(index, 1);
          }
        },
        changeTrigger(trigger) {
        },
        changeSymbol(symbol) {

        },
        changeIndentForHttp(indent,index,$event){
          let flag = false;
          for (let i=0;i<this.triggerList.length;i++){
            if(i != parseInt(index)){
              if(this.triggerList[i].funcKey == $event){
                flag = true;
                this.$message.info('http分支动作不允许重复');
                this.triggerList[index].funcKey = this.keyParam;
                break;
              }
            }
          }
          if(flag){
            return false;
          }
          if (this.triggerList.length > 0 && this.indentListHttp.length > 0) {
            this.indentListHttp.forEach(i=>{
              i.disabled = false
              if (indent.funcKey === i.id) {
                this.$emit('updateRecognizeLabel',indent,i)
              }
            })
          }
        },
        changeIndent(indent,index,$event) {
          let flag = false;
          for (let i=0;i<this.triggerList.length;i++){
            if(i != parseInt(index)){
              if(this.triggerList[i].funcKey == $event){
                flag = true;
                this.$message.info('按键不允许重复');
                this.triggerList[index].funcKey = this.keyParam;
                break;
              }
            }
          }
          if(flag){
            return false;
          }
          if (this.triggerList.length > 0 && this.indentList.length > 0) {
            this.indentList.forEach(i=>{
              i.disabled = false
              if (indent.funcKey === i.id) {
                this.keyParam = indent.funcKey;
                this.$emit('updateRecognizeLabel',indent,i)
              }
            })
          }
        },
        changeJudgeLabel(judge) {
          this.$emit('updateJudgeLabel',judge)
        },
        changeNextScene(nextScene) {

        },
        deleteTrigger(trigger) {
          let temp = {}
          $.extend(true,temp,trigger)
          let index = this.triggerList.indexOf(trigger)
          //let temp = JSON.parse(JSON.stringify(trigger))

          if (index > -1) {
            if (this.indentList.length > 0) {
              this.indentList.forEach(i=>{
                if (i.id === trigger.funcKey) {
                  i.disabled = false
                }
              })
            }
            if (temp.id) {
              this.deleteRecognizes.push(temp.id+'')
            }
            this.triggerList.splice(index, 1);
            this.$emit('deleteRecognize',trigger)
          }
        },
        changeMethod(method) {

        },
        changeQuery(method,scope) {
          if("callcenter_number" == method || "customer_uuid" == method || "customer_number" == method || "接入号" == method || "客户呼叫ID" == method || "客户号码" == method){
            scope.type = "0";
          }else{
            scope.type = "2";
          }
        },
        handleTabClick(tabName) {

        },
        addHttpQuery(type) {
          if('1' == type){
            this.httpData.httpVariable.push({id:'',type:'1',rsId:'',name:'',requestKey: ''})
          }else{
            this.httpData.httpVariable.push({id:'',type:'2',rsId:'',name:'',requestKey: ''})
          }
        },
        addHttpHeader() {
          this.httpData.head.push({name:'',value: ''})
        },
        handleDeleteQuery(index, row) {
          if (this.httpData.httpVariable.length > index) {
            if (row.id) {
              this.deleteQueries.push(row.id+'')
            }
            this.httpData.httpVariable.splice(index,1);
          }
        },
        handleDeleteHeader(index, row) {
          if (this.httpData.head.length > index) {
            this.httpData.head.splice(index,1);
          }
        },
        deleteOr(index,or) {
          let oindex = this.judgeElementList[index].or.indexOf(or)
          if (oindex > -1) {
            if (or.id) {
              this.deleteOrs.push(or.id+'')
            }
            this.judgeElementList[index].or.splice(oindex,1);
          }
        },
        deleteCondition(condition) {
          let index = this.judgeElementList.judgeVariable.indexOf(condition)
          if (index > -1) {
            if (condition.id) {
              this.deleteBranches.push(condition.id+'')
            }
            this.judgeElementList.judgeVariable.splice(index,1);
            this.$emit('deleteJudge',condition)
          }
        },
        closeDialog(val) {
          if (!val) {
            this.showDialog = val
          }
        },
        initBind() {
          let that = this
          eventBus.$on('addRecognize', item => {
            if (that.showDrawer) {
              if (that.model.id === item.rsId) {
                let has = that.triggerList.filter(t=>{
                  return t.rsId === item.rsId && t.nodeId === item.nodeId
                })
                //let index = that.triggerList.indexOf(has)
                if (has.length<=0) {
                  that.triggerList.push(item)
                }
              }
            }

          })
          eventBus.$on('addJudgeBranch',item=>{
            if (that.showDrawer) {
              if (that.model.id === item.rsId) {
                let branch = that.judgeElementList.judgeVariable.filter(b=>{
                  return b.rsId === item.rsId && b.nodeId === item.nodeId
                })
                //let index = that.judgeElementList.indexOf(branch)
                if (branch.length <= 0) {
                  that.judgeElementList.judgeVariable.push(item);
                }
                that.judgeList = that.judgeElementList.judgeVariable;
              }
            }

          })
          eventBus.$on('deleteRecognize',item=>{
            if (that.showDrawer) {
              if (item) {
                let trigger = that.triggerList.find(t=>{
                  return t.nodeId === item.nodeId
                })
                let index = that.triggerList.indexOf(trigger)
                if (index > -1) {
                  that.triggerList.splice(index,1);
                }
              }
            }
          })
          eventBus.$on('deleteJudge',item=>{
            if (that.showDrawer) {
              if (item) {
                let index = that.judgeList.indexOf(trigger)
                if (index > -1) {
                  that.judgeList.splice(index,1);
                }
              }
            }
          })
        },
      },
      computed: {
        placementComputed() {
          return this.placement ? 'right' : 'left'
        }
      },
      created() {
        this.screenHeight.height = this.mountHeight(91+40)
        this.initBind()
      },
      destroyed() {
        eventBus.$off('addRecognize')
        eventBus.$off('addJudgeBranch')
        eventBus.$off('deleteRecognize')
        eventBus.$off('deleteJudge')
      },
      watch: {
         nodeShow: {
          deep: true,
          immediate: true,
           async handler(val) {
             if (val) {
               this.width = 700
               if (this.flowId) {
                 await this.initSelectData(this.flowId);
                 this.searchVoiceFile();
               }
             }
             this.showDrawer = val
          }
        },
        'model.id': {
          deep:true,
          immediate:true,
          async handler(val,oldValue) {
            this.sceneId = val
            if (this.nodeShow) {
              if (this.flowId) {
                await this.initSelectData(this.flowId);
              }
            }
            if (val !== oldValue) {
              //先上传
              if (this.showDrawer) {
                this.generatorUpdateData();
              }
              this.resetData();
              if(this.model && "开始节点" != this.model.name){
                if (this.model.nodeData) {
                  this.generatorData(this.model);
                } else {
                  console.log("load node data error !");
                }
              }
              let name = this.model.name;
              this.icon = this.model.icon;
              this.label = this.model.label;
              this.labelName = this.model.label;
              switch (name) {
                case '下级菜单':
                  if("1" == this.model.isTop){
                    this.showType = [true,false,false,false,false,true,false];
                  }else{
                    this.showType = [true,false,false,false,false,false,false];
                  }
                  this.label1 = '语音文件设置'
                  this.label2 = '按键设置'
                  this.tips = '连接节点，自动添加按键识别'
                  this.label3 = '高级设置'
                  this.scene.rsType = '1'
                  this.addAction();
                  this.getQueue("3");
                  break
                case '语音节点':
                  this.showType = [true,false,false,false,true,false,false]
                  this.label1 = '语音文件设置'
                  this.label2 = '按键设置'
                  this.tips = '连接节点，自动添加按键识别'
                  this.label3 = '收号信息设置'
                  this.scene.rsType = '2'
                  break
                case '判断节点':
                  this.showType = [false,true,false,false,false,false,false]
                  this.label1 = '交互设置'
                  this.label2 = '条件设置'
                  this.tips = '连接节点，自动添加条件分支'
                  this.label3 = '分支条件设置'
                  this.scene.rsType = '5'
                  break
                case 'HTTP节点':
                  this.showType = [false,false,true,false,false,false,false]
                  this.label1 = '交互设置'
                  this.label2 = '分支设置'
                  this.tips = '连接节点，自动添加条件分支'
                  this.label3 = '分支条件设置'
                  this.scene.rsType = '3'
                  break
                case '跳转节点':
                  this.showType = [false,false,false,true,false,false,true]
                  this.label1 = '交互设置'
                  this.label2 = '分支设置'
                  this.tips = '连接节点，自动添加条件分支'
                  this.label3 = '分支条件设置'
                  this.scene.rsType = '3'
                  break
                case '转接节点':
                  if("1" == this.model.isTop){
                    this.showType = [false,false,false,true,false,true,false];
                  }else{
                    this.showType = [false,false,false,true,false,false,false];
                  }
                  this.label1 = '语音文件设置'
                  this.label2 = '转接设置'
                  this.tips = '连接节点，自动添加条件分支'
                  this.label3 = '分支条件设置'
                  this.scene.rsType = '4'
                  this.addAction();
                  this.getQueue("3");
                  break
                default:
                  break
              }
            }
          }
        },
        nodeList:{
           immediate:true,
          deep:true,
          handler(value) {
             this.nodes = this.nodeList
          }
        },
        paramListForAll:{
          immediate:true,
          deep:true,
          handler(value) {
            this.paramList = this.paramListForAll
          }
        },
        httpParamList:{
          immediate:true,
          deep:true,
          handler(value) {
            this.paramListHttp = this.httpParamList
          }
        }
      }
    }
</script>

<style scoped lang="css">
.label_line{
  height: 35px;
  line-height: 35px;
  text-align: left;
  background-color: #D3DCE6;
  width: 100%;
  margin-left: -16px;
  margin-right: -16px;
  padding-left: 16px;
}
  .param{
    margin: 10px;
  }
  .paramTip{
    border-radius: 5px;
    border: 1px solid #2d8cf0;
    margin-right:25px;
    padding: 5px 10px;
    background-color: #97CBFF;
  }

  a{
    color: #3da8f1;
  }
  .el-input__inner{
    padding: 0 10px;
  }
.top-icon{
  width: 23px;
  height: 23px;
}
.tip-img {
  max-width: 13px;
  max-height: 13px;
  font-size: 14px;
}
.img_div{
  width: 7%;
  line-height: 44px;
  text-align: center;
}
img{
  height: 25px;
  width: 25px;
}
.single_input{
  width: 100%;
  padding-top: 10px;
}
.font_style_set{
  width: 25%;
  float: left;
}
.ivu-input-wrapper{
  width: 60%;
}
.ivu-select{
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/IvrNodeDrawer.vue